import SortDropdownController from "../../pos_controllers/products/sort_dropdown_controller"

export default class extends SortDropdownController {
  // Override connect to work with Bootstrap dropdown (no manual open/close needed)
  connect() {
    // Don't call super.connect() as it sets up Tailwind-specific hidden/block classes
    // Bootstrap handles dropdown visibility via data-toggle="dropdown"
    this.isOpen = false
    this.updateIndicator()
  }

  findSearchForm() {
    return document.querySelector('form[data-controller*="select--advanced-filter"]')
  }

  findSortFields(searchForm) {
    if (!searchForm) return { sortColumnField: null, sortDirectionField: null }

    const sortColumnField = searchForm.querySelector('input[name="persisted_search[sort_column]"]')
    const sortDirectionField = searchForm.querySelector('input[name="persisted_search[sort_direction]"]')
    return { sortColumnField, sortDirectionField }
  }

  // Override disconnect to skip POS teardown
  disconnect() {
    // Bootstrap handles its own click outside behavior
  }

  // Override setSortAndSubmit to use BackOffice form selector
  setSortAndSubmit(event) {
    event.preventDefault()
    event.stopPropagation() // Keep dropdown open
    
    const button = event.currentTarget
    const sortColumn = button.dataset.sortColumn
    const defaultDirection = (button.dataset.defaultDirection || "desc").toLowerCase()

    const searchForm = this.findSearchForm()
    const { sortColumnField: currentSortColumnField, sortDirectionField: currentSortDirectionField } = this.findSortFields(searchForm)
    const currentColumn = currentSortColumnField && currentSortColumnField.value
    const currentDirection = (currentSortDirectionField && currentSortDirectionField.value || defaultDirection).toLowerCase()
    const isSameColumn = currentColumn === sortColumn
    const newDirection = isSameColumn
      ? (currentDirection === "asc" ? "desc" : "asc")
      : defaultDirection

    // Update dataset on the button
    button.dataset.sortDirection = newDirection

    // Update label
    const labelAsc = button.dataset.labelAsc
    const labelDesc = button.dataset.labelDesc
    const labelElement = button.querySelector('[data-sort-label]')
    if (labelElement && (labelAsc || labelDesc)) {
      labelElement.textContent = newDirection === "asc" ? labelAsc : labelDesc
    }

    // Update arrow
    const arrowElement = button.querySelector('[data-sort-arrow]')
    if (arrowElement) {
      arrowElement.textContent = newDirection === "desc" ? "↓" : "↑"
    }

    // Update hidden fields
    if (currentSortColumnField) currentSortColumnField.value = sortColumn
    if (currentSortDirectionField) currentSortDirectionField.value = newDirection

    // Update highlighting
    this.updateDropdownHighlighting(sortColumn, newDirection)

    // Update indicator
    this.updateIndicator()

    if (searchForm) {
      setTimeout(() => {
        try {
          searchForm.requestSubmit()
        } catch (error) {
          console.error("requestSubmit failed:", error)
          try {
            searchForm.submit()
          } catch (error2) {
            console.error("submit also failed:", error2)
          }
        }
      }, 100)
    } else {
      console.error("Search form not found!")
    }
  }

  // Override updateDropdownHighlighting for Bootstrap classes
  updateDropdownHighlighting(activeColumn, activeDirection) {
    const sortButtons = this.element.querySelectorAll('button[data-sort-column]')
    sortButtons.forEach(button => {
      const buttonColumn = button.dataset.sortColumn
      const buttonDirection = button.dataset.sortDirection
      const isActive = buttonColumn === activeColumn && buttonDirection === activeDirection
      const arrow = button.querySelector('[data-sort-arrow]')
      
      if (isActive) {
        // Bootstrap active styling
        button.classList.remove('text-muted')
        button.classList.add('font-weight-bold', 'text-dark')
        if (arrow) {
          arrow.classList.remove('d-none')
        }
      } else {
        // Bootstrap inactive styling
        button.classList.remove('font-weight-bold', 'text-dark')
        button.classList.add('text-muted')
        if (arrow) {
          arrow.classList.add('d-none')
        }
      }
    })
  }

  // Override updateIndicator for Bootstrap styling
  updateIndicator() {
    const searchForm = this.findSearchForm()
    const { sortColumnField } = this.findSortFields(searchForm)
    
    if (sortColumnField && sortColumnField.value && this.hasButtonTarget) {
      // Bootstrap border styling
      this.buttonTarget.classList.add('border-primary')
      this.buttonTarget.style.borderWidth = '2px'
    } else if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove('border-primary')
      this.buttonTarget.style.borderWidth = ''
    }
  }
}
